import { RecordDto } from "@/core/common/entities/record.dto";
import { getPointPricePositionLabel } from "@/core/features/users/get-point-price-position-label";
import { PointPricePositionEnum } from "@altertec_gparn/lib";
import { get } from "lodash";
import { toEuros, toHours } from "@/utils/numberUtils";
import { formatAppDate, parseApiDate } from "@/utils/dates/dateFormats";

const CURRENCY_FIELDS = new Set([
  "hourlyRate",
  "payrollHourlyRate",
  "payrollExtraHourlyRate",
  "payrollHolidayHourlyRate",
  "teamLeadDailyRate",
  "abroadWorkGeneralDailyRate",
  "abroadWorkTeamLeaderDailyRate",
]);

const DATE_FIELDS = new Set(["hiredDate", "lastEmploymentDate"]);

const BOOLEAN_FIELDS = new Set(["archived", "isPlannable"]);

export class UserRecordDto extends RecordDto {
  userId: string;
  translateEntityName = "el empleado";

  translateKeys = {
    firstName: "el nombre",
    lastName: "el apellido",
    internalCode: "el código interno",
    hourlyRate: "el precio/hora (coste)",
    payrollHourlyRate: "el precio/hora (nóminas)",
    payrollExtraHourlyRate: "el precio/hora extra (nóminas)",
    payrollHolidayHourlyRate: "el precio/hora extra festivo (nóminas)",
    teamLeadDailyRate: "el precio/día jefe de equipo (nóminas)",
    abroadWorkGeneralDailyRate: "el plus desplazamiento general (nóminas)",
    abroadWorkTeamLeaderDailyRate: "el plus desplazamiento jefe (nóminas)",
    dailyMinutes: "las horas/día",
    pointPricePosition: "el puesto para calcular puntos",
    collectiveAgreementId: "el convenio colectivo",
    collectiveAgreementCategoryId: "la categoría del convenio",
    operativeUnitId: "la unidad operativa",
    companyId: "la empresa",
    roleId: "el rol",
    hiredDate: "la fecha de contratación",
    lastEmploymentDate: "la fecha de última contratación",
    archived: "archivado",
    isPlannable: "planificable",
    companyPhone1: "el teléfono empresa",
    companyPhone2: "el teléfono empresa 2",
  };

  getTargetField(): string {
    if (!this.targetField) return;
    return get(this.translateKeys, this.targetField, this.targetField);
  }

  transformFn(value: unknown, originalValue: unknown): string {
    if (CURRENCY_FIELDS.has(this.targetField)) {
      return value !== null && value !== undefined && !isNaN(Number(value)) ? `${toEuros(Number(value))}€` : "0€";
    }

    if (this.targetField === "dailyMinutes") {
      const minutes = Number(originalValue ?? value ?? 0);
      return `${toHours(minutes)}h`;
    }

    if (this.targetField === "pointPricePosition") {
      return getPointPricePositionLabel(value as PointPricePositionEnum) ?? String(value ?? "-");
    }

    if (DATE_FIELDS.has(this.targetField)) {
      if (!originalValue) return "-";
      return formatAppDate(parseApiDate(String(originalValue)));
    }

    if (BOOLEAN_FIELDS.has(this.targetField)) {
      return value === true || value === "true" ? "Sí" : "No";
    }

    return super.transformFn(value, originalValue);
  }
}
